import Anchor from '../common/anchor';
import Image from '../common/image';
import BlogCard from './../home/blogCard';
import useBlogDashboard from './../../hooks/useBlogDashboard';

const about = {
	path: '/about',
	name: 'About',
	title: 'About BEM Foundation',
	content: (theme) => (
		<div className='container py-5'>
			<div className='row'>
				<div className='offset-md-3 col-md-6 col-12 text-center'>
					<Image
						className='w-50 mb-4'
						fileName='bemFoundation.webp'
					/>
				</div>

				<div className='col-12'>
					<h1 className='fw-bold'>BEM Foundation</h1>

					<h3 className='fw-bold mt-5'>Empowering Blockchain Innovation Since 2020</h3>
					<p>
						The <b>BEM Foundation</b> was established in 2020 as a pioneering force in
						the global blockchain industry. Built by a team of seasoned professionals in
						cryptocurrency, blockchain development, and strategic marketing, the
						foundation’s mission is to foster a robust blockchain-based ecosystem and
						unlock global job opportunities in this transformative field.
					</p>
					<p>
						Rooted in the core principles of decentralization, the <b>BEM Foundation</b>{' '}
						upholds a strong commitment to security and transparency. To protect the
						integrity of its projects, the identities of its founding members remain
						undisclosed—mirroring the decentralized nature of blockchain itself.
					</p>
					<p>
						We identify evolving market needs and design accessible blockchain
						solutions, empowering people from all backgrounds to understand, engage
						with, and benefit from blockchain technology
					</p>

					<h3 className='fw-bold mt-5'>The Best Economic Money Foundation</h3>
					<p>
						As its name suggests, BEM—<b>Best Economic Money</b>—is dedicated to
						enabling financial empowerment through decentralized systems. Our expert
						team, each with years of experience, leads strategic projects with a shared
						vision of building sustainable blockchain infrastructures. From financial
						innovation to ecosystem expansion, the <b>BEM Foundation</b> is a trusted
						guide for users and investors alike.
					</p>
					<h3 className='fw-bold mt-5'>Our Journey</h3>
					<p>
						The foundation's first initiative was the launch of its own token through an
						Initial Coin Offering (ICO), followed by a staking platform that added value
						and liquidity to the ecosystem. Just six months later, the <b>BemChain</b>{' '}
						platform was launched—serving as the official Launchpad for future BEM
						projects and rapidly becoming a pivotal growth engine.
					</p>
					<p>
						Initially managed in a decentralized format, the foundation transitioned to
						a more structured approach in 2021 by opening its first official office in
						<b>Armenia</b>. As user adoption soared—reaching over{' '}
						<b>25,000 active members on BemChain</b>. the foundation expanded further by
						opening a second office in <b>Istanbul, Turkey,</b> a top-five hub in global
						crypto trading.
					</p>
					<p>
						The next strategic milestone is to open a support center in <b>Dubai,</b>{' '}
						the emerging capital of blockchain innovation, solidifying{' '}
						<b>BEM Foundation</b>
						’s global presence and accessibility by 2024.
					</p>

					<h3 className='fw-bold mt-5'>Our Core Values</h3>
					<p>
						At <b>BEM Foundation</b> and our associated platforms such as{' '}
						<b>MMP WORLD</b>, we are driven by a steadfast commitment to:
					</p>

					<ul>
						<li>
							<b>Project Integrity</b>: We bring ideas to life by completing and
							launching real-world blockchain projects.
						</li>
						<li>
							<b>User Protection</b>: We implement strict risk management protocols
							and ethical standards.
						</li>
						<li>
							<b>Financial Empowerment</b>: We aim to unlock diverse income
							opportunities and financial independence through blockchain-based
							investment models.
						</li>
					</ul>

					<p>
						Whether you're a visionary, investor, or curious learner,{' '}
						<b>BEM Foundation</b>
						invites you to join a global movement where innovation meets impact.
					</p>

					<div className='text-center my-5'>
						<Anchor
							className={`fs-5 defaultLink text-set3-${theme}`}
							href='https://bemfoundation.com'
							content={
								<>
									<i className='fas fa-link me-2'></i>
									<span>
										<b>Visit Us</b> → bemfoundation.com
									</span>
								</>
							}
						/>
					</div>
				</div>
			</div>
		</div>
	),
};

export default about;
